import axios from "axios";
import qs from "qs";
import config from "../../config/config.js";
import Cookies from 'js-cookie'
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';

var URI = config.apiDomain

var ax = axios.create({
  baseURL: URI,
  timeout: 2000000,
  headers: {
    // 'Content-Type':'application/x-www-form-urlencoded',
    // 'token': Cookies.get("token")
  }
})

//每次发送请求都携带token
ax.interceptors.request.use(config => {

  var token = Cookies.get("token")
  // console.log("token===",token)
  if (token) {
    config.headers.token = token; //每次访问携带token
  }
  return config;
},
  err => { return Promise.reject(err); })

// 拦截器
ax.interceptors.response.use(data => {
  return data
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        MessageBox('当前登录已过期，请重新登录！', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          // cancelButtonText: '取消'
        })
          .then(() => {
            //跳转登录
            // window.location.href = 'https://127.0.0.1:8090/#/'
            window.location.href = 'https://ssx.fzjiading.com/bxback/#/'
          })
          .catch(action => {

          });
        break;
      case 403:
        Message({
          message: "没有该权限，请联系管理员",
          type: "warning"
        })
        break;
    }
  }
  return Promise.reject(error)
})

export var itr = (type, url, params) => {
  if (typeof params !== 'object') {
    params = {}
  }
  let arg = qs.stringify(params)
  return ax[type](url, arg)
}

// Ajax API start
export const g = (url, params) => {
  return base('get', url, params)
}

export const p = (url, params, mask, clear, silent) => {
  return base('post', url, params, mask, clear, silent)
}

export const d = (url, params) => {
  return base('delete', url, params)
}

export const u = (url, params) => {
  return base('put', url, params)
}
export const pa = (url, params) => {
  return base('patch', url, params)
}

export const op = (url, params) => {
  return base('options', url, params)
}
// Ajax API end

export function base (type, url, params, mask = false, clear = true, silent = false) {
  return new Promise((resolve, reject) => {
    itr(type, url, params).then((response) => {
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject(response.data)
      }
    }).catch((msg) => {
      if (!msg.response) {
        // alert('服务器连接超时')
      } else {
        // alert(msg.response.status + ':' + msg.response.statusText)
      }
      reject(msg.message)
    })
  })
}



// ----------------------------------------------传json
var axJson = axios.create({
  baseURL: URI,
  timeout: 200000,
  headers: {
    "Content-Type": "application/json",
  }
});


//每次发送请求都携带token
axJson.interceptors.request.use(config => {

  var token = Cookies.get("token")
  // console.log("token===",token)
  if (token) {
    config.headers.token = token; //每次访问携带token
  }
  return config;
},
  err => { return Promise.reject(err); })

// 拦截器
axJson.interceptors.response.use(data => {
  return data
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        MessageBox('当前登录已过期，请重新登录！', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          // cancelButtonText: '取消'
        })
          .then(() => {
            //跳转登录
            window.location.href = 'https://ssx.fzjiading.com/bxback/#/'
            // window.location.href = 'https://127.0.0.1:8090/#/'
          })
          .catch(action => {

          });
        break;
      case 403:
        Message({
          message: "没有该权限，请联系管理员",
          type: "warning"
        })
        break;
    }
  }
  return Promise.reject(error)
})


export var itrJson = (type, url, params) => {
  if (typeof params !== 'object') {
    params = {}
  }
  let arg = JSON.stringify(params);
  // let arg = qs.stringify(params)
  return axJson[type](url, arg)
}

// Ajax API start
export const pJson = (url, params, mask, clear, silent) => {
  return baseJson('post', url, params, mask, clear, silent)
}
// Ajax API end

export function baseJson (type, url, params, mask = false, clear = true, silent = false) {
  return new Promise((resolve, reject) => {
    itrJson(type, url, params).then((response) => {
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject(response.data)
      }
    }).catch((msg) => {
      if (!msg.response) {
        // alert('服务器连接超时')
      } else {
        // alert(msg.response.status + ':' + msg.response.statusText)
      }
      reject(msg.message)
    })
  })
}



// ----------------------------------------------传Blob
var axJsonBlob = axios.create({
  baseURL: URI,
  timeout: 200000,
  headers: {
    "Content-Type": "application/json",
  }
});

export var itrJsonBlob = (type, url, params) => {
  if (typeof params !== 'object') {
    params = {}
  }
  let arg = JSON.stringify(params);
  // let arg = qs.stringify(params)
  return axJsonBlob[type](url, arg)
}

// Ajax API start
export const pJsonBlob = (url, params, mask, clear, silent) => {
  return baseJsonBlob('post', url, params, mask, clear, silent)
}
// Ajax API end

export function baseJsonBlob (type, url, params, mask = false, clear = true, silent = false) {
  return new Promise((resolve, reject) => {
    itrJsonBlob(type, url, params).then((response) => {
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject(response.data)
      }
    }).catch((msg) => {
      if (!msg.response) {
        // alert('服务器连接超时')
      } else {
        // alert(msg.response.status + ':' + msg.response.statusText)
      }
      reject(msg.message)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/instrance.js